const getters = {
  name: (state) => state.user.info.real_name,
  username: (state) => state.user.info.username,
  user_id: (state) => state.user.info.id,
  email: (state) => state.user.info.email,
  userInfo: (state) => state.user.info,
  roles: (state) => state.user.roles,
  partnerInfo: (state) => state.user.partnerInfo,

  fontList: (state) => state.config.fontList,
  languages: (state) => state.config.languages,
  veditor_languages: (state) => state.config.veditor_languages,

  permission_routers: (state) => state.permission.routers,
  accessibleRouters: (state) => state.permission.accessibleRouters,
  currentRouter: (state) => state.permission.currentRouter,
}
export default getters
